import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import './assets/fonts/fonts.less'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment'
import clipboard from 'clipboard'

Vue.use(ElementUI)

Vue.prototype.$clipboard = clipboard
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
